export type BuildCloudImageUrlParams = {
  height: number;
  token: string;
  url: string;
  width: number;
};

export type BuildPrismicImageUrlParams = {
  height: number;
  url: string;
  width: number;
};

export const buildCloudImageUrl = ({ height, token, url, width }: BuildCloudImageUrlParams) =>
  `https://${token}.cloudimg.io/v7/${url}?func=crop&w=${width}&h=${height}`;

export const buildPrismicImageUrl = ({ height, url, width }: BuildPrismicImageUrlParams) =>
  `${url.split('?')[0]}?fit=crop&w=${width}&h=${height}&auto=compress,format&lossless=true`;
